// extracted by mini-css-extract-plugin
export default {"account":"AccountButton_account__+p0Gr","avatar":"AccountButton_avatar__Zq75O","link":"AccountButton_link__gY6bj","buttonPrimary":"AccountButton_buttonPrimary__zOHuD"};